// extracted by mini-css-extract-plugin
export default {"navbutton":"NavButton_navbutton__LXXC8"};